import React, { useContext } from "react";
import { BadgeStatus } from "@deere/fuel-react";
import ErrorContext from "./error-context";
import { useTranslation } from "./translation-context";

const BadgeStat = () => {
  const ctx = useContext(ErrorContext);
  const {translate:t} = useTranslation();
  return (
    <div>
      {t("errors")}
      <BadgeStatus
        align="right"
        content={ctx.popUpData}
        variant="error"
        style={{ marginLeft: "16px", marginRight: "12px" }}
      ></BadgeStatus>
    </div>
  );
};

export default BadgeStat;
